import React from 'react'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import {
    FormGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    Radio,
    Button,
    MenuItem
} from '@material-ui/core'
import {
    renderCheckBox,
    renderRadioGroup,
    renderTextArea,
    renderSelect
} from './RenderComponent'
import { FORM_REQUISITION } from '../../utils/CommonConstant'
import  {
    sourcingAndSelectionValidation
} from "../form/Validation"

const SourcingAndSelectionForm = (props) => {

    const {
        classes, 
        back,
        pristine,
        submitting,
        lengthOfAdvertistment,
        handleSubmit
    } = props



    return (
        // <form className={classes.form} onSubmit={() => next()}>
        <form className={classes.form}>
            <GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    
                    <FormControl component="fieldset">
                        <FormLabel>
                            Standard Advertisting Channels
                        </FormLabel>
                        
                        <FormGroup row>
                            <Field 
                                name="channel_1" 
                                component={renderCheckBox}
                                value="jobnet" 
                                label="Job Net" 
                            />
                            
                            <Field 
                                name="channel_2"
                                value="linkedin" 
                                component={renderCheckBox} 
                                label="LinkedIn"
                            />
                        </FormGroup>
                    </FormControl>
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <FormControl component="fieldset" style={{marginTop: "15px"}}>

                    <FormLabel >
                        International Advertisement?
                    </FormLabel>

                    <Field 
                        name="international"
                        component={renderRadioGroup}
                        >

                            <FormControlLabel
                                label="Yes"
                                value="yes"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                            <FormControlLabel
                                label="No"
                                value="no"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                    </Field>

                </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <FormControl component="fieldset" style={{marginTop: "15px"}}>

                        <FormLabel>
                            Advertise or Full recruitment process (Full Recruitement process means e.g. : shortlisted, interview arrangement, salary negotiations, etc.)
                        </FormLabel>

                        <Field 
                            name="process"
                            component={renderRadioGroup}
                            >
 
                            <FormControlLabel
                                label="Advertise"
                                value="advertise"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                            <FormControlLabel
                                label="Full Recruitment"
                                value="full_recruitment"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                        </Field>

                    </FormControl>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                   
                    <FormControl component="fieldset" style={{marginTop: "15px"}}>

                    <FormLabel>
                        All applications or shortlist only?
                    </FormLabel>

                    <Field 
                        name="source"
                        component={renderRadioGroup}
                        >

                            <FormControlLabel
                                label="All"
                                value="all"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                            <FormControlLabel
                                label="Shortlist"
                                value="shortlist"
                                control = {
                                    <Radio  color="secondary"/>
                                }
                            />

                        </Field>

                    </FormControl>

                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        style={classes.input}
                        name="length"
                        component={renderSelect}
                        label="Length of Advertisement"
                        label_width={175}
                    >
                       {
                           lengthOfAdvertistment.map((value, key) => 
                                <MenuItem value={value} key={key}>
                                    { value+" Week" }
                                </MenuItem>
                           )
                       }
                    </Field>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        
                        name="additional_requirment"
                        component={renderTextArea}
                        label="Additional requirment/ Comment"
                    />
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                      <div className="Button-Holder">
                        <Button
                          className={classes.prev_button}
                          variant="contained"
                          onClick={() => back()}>
                          Previous
                        </Button>
                      </div>
                      
                </GridItem>

                <GridItem xs={12} sm={6} md={6}>
                    <div className="Button-Holder">
                      <Button
                        className={classes.button}
                        // type="submit"
                        //onClick={() => next()}
                        onClick={handleSubmit}
                        variant="contained"
                        color ="secondary"
                        disabled={pristine || submitting}
                        >
                            Next
                        </Button>
                    </div>
                </GridItem>

            </GridContainer>
        </form> 
    )
} 

SourcingAndSelectionForm.propTypes = {
    classes: PropTypes.object.isRequired
}

export default reduxForm({
    form: FORM_REQUISITION,
    destroyOnUnmount: false,        
    forceUnregisterOnUnmount: true,
    validate: sourcingAndSelectionValidation
})(withStyles(requisitionFormStyle) (SourcingAndSelectionForm))






















